import { render } from "./StandAloneAccountability.vue?vue&type=template&id=a83e085a&scoped=true"
import script from "./StandAloneAccountability.vue?vue&type=script&lang=js"
export * from "./StandAloneAccountability.vue?vue&type=script&lang=js"

import "./StandAloneAccountability.vue?vue&type=style&index=0&id=a83e085a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83e085a"]])

export default __exports__